import { configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';

import movieReducer from "../features/movie/movieSlice";
import watchLaterReducer from '../features/movie/watchLaterSlice';

/* 
    This is the store that stores all the reducers we created. The reducers we created manages the states of objects.
*/

export default configureStore({
    reducer: {
        movie: movieReducer,
        watchLater: watchLaterReducer,
    },

    middleware: getDefaultMiddleware({
        serializableCheck: false, 
    }),
});
